import styled from "styled-components";

export const LandingDescriptionWrapper = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    position: relative;
`;

export const HowItWorksTrigger = styled.button`
    align-items: center;
    background: none;
    border: 1px solid rgba(255, 255, 255, 0.4);
    border-radius: 8px;
    box-sizing: border-box;
    color: #FFFFFF;
    cursor: pointer;
    display: flex;
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 600;
    justify-content: center;
    line-height: 1;
    max-height: 44px;
    padding: 12px 24px;
    text-align: center;

    transition: background-color 0.2s ease, border-color 0.2s ease, opacity 0.2s ease;

    &:hover {
        background: rgba(255, 255, 255, 0.1);
        border-color: rgba(255, 255, 255, 0.6);
        opacity: 1;
    }
`;

export const SeparatorLine = styled.div`
    background: rgba(255, 255, 255, 0.3);
    height: 1px;
    opacity: 0.67;
    width: 80%;
    @media (max-width: 768px) {
        width: 90%;
    }
`;

export const FirstRow = styled.div`
    align-items: center;
    backdrop-filter: blur(100px);
    -webkit-backdrop-filter: blur(100px);
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 32px;
    justify-content: center;
    margin-top: 144px;
    min-height: 460px;
    padding: 48px 24px;
    width: 100%;
`;

export const SecondRow = styled.div`
    backdrop-filter: blur(100px);
    -webkit-backdrop-filter: blur(100px);
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    box-sizing: border-box;
    padding: 48px 24px;
    position: absolute;
    top: 96px;
    width: 90%;
    min-height: 460px;
    z-index: -1
`;
export const ThirdRow = styled.div`
    backdrop-filter: blur(100px);
    -webkit-backdrop-filter: blur(100px);
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 16px;
    box-sizing: border-box;
    padding: 48px 24px;
    position: absolute;
    top: 48px;
    width: 80%;
    min-height: 460px;
    z-index: -2;
`;